module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card-title', [_vm._v("Vereinsanschrift")]), _vm._v(" "), _c('v-row', {
    staticClass: "pa-2 pt-4"
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Vereinsname"
    },
    model: {
      value: (_vm.settings.name),
      callback: function($$v) {
        _vm.$set(_vm.settings, "name", $$v)
      },
      expression: "settings.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Straße"
    },
    model: {
      value: (_vm.settings.strasse),
      callback: function($$v) {
        _vm.$set(_vm.settings, "strasse", $$v)
      },
      expression: "settings.strasse"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Nr."
    },
    model: {
      value: (_vm.settings.hausnummer),
      callback: function($$v) {
        _vm.$set(_vm.settings, "hausnummer", $$v)
      },
      expression: "settings.hausnummer"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Ort"
    },
    model: {
      value: (_vm.settings.ort),
      callback: function($$v) {
        _vm.$set(_vm.settings, "ort", $$v)
      },
      expression: "settings.ort"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "PLZ"
    },
    model: {
      value: (_vm.settings.plz),
      callback: function($$v) {
        _vm.$set(_vm.settings, "plz", $$v)
      },
      expression: "settings.plz"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Land"
    },
    model: {
      value: (_vm.settings.land),
      callback: function($$v) {
        _vm.$set(_vm.settings, "land", $$v)
      },
      expression: "settings.land"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card-title', [_vm._v("Webadressen")]), _vm._v(" "), _c('v-row', {
    staticClass: "pa-2 pt-4"
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Haupt Mailadresse"
    },
    model: {
      value: (_vm.settings.mail),
      callback: function($$v) {
        _vm.$set(_vm.settings, "mail", $$v)
      },
      expression: "settings.mail"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Webseite"
    },
    model: {
      value: (_vm.settings.webseite),
      callback: function($$v) {
        _vm.$set(_vm.settings, "webseite", $$v)
      },
      expression: "settings.webseite"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Instagram"
    },
    model: {
      value: (_vm.settings.instagram),
      callback: function($$v) {
        _vm.$set(_vm.settings, "instagram", $$v)
      },
      expression: "settings.instagram"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Facebook"
    },
    model: {
      value: (_vm.settings.facebook),
      callback: function($$v) {
        _vm.$set(_vm.settings, "facebook", $$v)
      },
      expression: "settings.facebook"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card-title', [_vm._v("Administratoren")]), _vm._v(" "), _c('v-row', {
    staticClass: "pa-2 pt-4"
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.bundesbruderselect,
      "outlined": "",
      "chips": "",
      "deletable-chips": "",
      "label": "Admins",
      "multiple": "",
      "dense": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                  Admins haben alle Rechte beim Verwenden von Korpodesk. Nur Admins können diese Einstellungen bearbeiten. Es muss min. 1 Admin ausgewählt werden.\n                ")])]
      },
      proxy: true
    }, {
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "mt-1",
          attrs: {
            "small": "",
            "input-value": data.selected,
            "close": _vm.settings.admins.length > 1
          },
          on: {
            "click": data.select,
            "click:close": function($event) {
              return _vm.removeBerechtigung(data.item.value)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(data.item.text) + "\n                ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.text)
          }
        })], 1)]
      }
    }]),
    model: {
      value: (_vm.settings.admins),
      callback: function($$v) {
        _vm.$set(_vm.settings, "admins", $$v)
      },
      expression: "settings.admins"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-372db8f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/Allgemein.vue
// module id = 758
// module chunks = 15